import { versionCheck } from '../../../helpers';

export class Voter {
    /**
     * @param {AccessPermissionRequest} request ACL request
     * @returns {boolean} Truthy if this voter supports this request
     */
    // eslint-disable-next-line no-unused-vars
    supports(request) {
        return false;
    }

    /**
     * @param {AccessPermissionRequest} request ACL request
     * @param {string} version Semver version matcher (e.g. `'>2.0'`, `'^5.1.x'`, `'~2.11||<3.1.0-alpha.1'`)
     * @returns {boolean} Returns <code>true</code> if semver `version` is matches request.
     */
    supportsVersion(request, version) {
        return versionCheck(request.user.workspace.projectVersion, version);
    }

    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * @param {AccessPermissionRequest} request ACL request
     * @returns {boolean|undefined|void} Returns <code>undefined</code> if this voter abstains from decision,
     * <code>true</code> if access should be granted, <code>false</code> - if denied.
     */
    // eslint-disable-next-line no-unused-vars
    vote(request) {}
}
